import { getSorter } from './getSorter';
import { resolveSortIcon } from './resolveSortIcon';
/**
 * Builds a simple sortable column.  It will use the sorter from the column definition if defined, otherwise it will add
 * a generic alpha or numeric sorter based on the data in the column
 * @param sortableColumns
 * @param column
 * @param data
 * @param theme
 * @param headerBackgroundColor
 */
export const buildSimpleSortableColumn = (sortableColumns, column, data, theme, headerBackgroundColor) => {
  if (sortableColumns || column.sorter) {
    return {
      ...column,
      sorter: getSorter(data, column),
      sortIcon: resolveSortIcon(theme, headerBackgroundColor)
    };
  }
  return column;
};